var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { AccordionSet, Accordion, Button } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { searchAgencyPublishers } from "../api/publisherService";
import { translateCollectionType } from "../utils/collectionTypeUtils";
import { CollectionTypeEnum } from "../types/Api";
import { formatPublisherLabel } from "../utils/formatPublisherLabel";
import { RecekTextField, RecekSelect, RecekSelection } from "./inputs";
export function CollectionsFilters(_a) {
    var temporaryTypeFilter = _a.temporaryTypeFilter, temporaryNameFilter = _a.temporaryNameFilter, temporaryPublisherFilter = _a.temporaryPublisherFilter, temporaryIssnFilter = _a.temporaryIssnFilter, publisherSearchQuery = _a.publisherSearchQuery, selectedPublisherData = _a.selectedPublisherData, selectedPublisherLoading = _a.selectedPublisherLoading, onTypeFilterChange = _a.onTypeFilterChange, onNameFilterChange = _a.onNameFilterChange, onPublisherFilterChange = _a.onPublisherFilterChange, onIssnFilterChange = _a.onIssnFilterChange, onPublisherSearchInput = _a.onPublisherSearchInput, onApplyFilters = _a.onApplyFilters;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _b = useQuery(["publisherSearch", publisherSearchQuery], function () {
        return searchAgencyPublishers(ky, {
            query: publisherSearchQuery
                ? "name=\"".concat(publisherSearchQuery, "*\" or name=\"*").concat(publisherSearchQuery, "*\"")
                : "cql.allRecords=1",
            offset: 0,
            limit: 100,
        });
    }, {
        enabled: !!publisherSearchQuery.trim(),
        staleTime: 30000,
        select: function (data) { var _a; return (_a = data.items) !== null && _a !== void 0 ? _a : []; },
    }), publisherSearchResults = _b.data, publishersLoading = _b.isLoading;
    var publisherOptions = useMemo(function () { return __spreadArray(__spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-agency.collectionsList.select.option.all",
            }),
        }
    ], (selectedPublisherData
        ? [
            {
                value: selectedPublisherData.sourceId,
                label: formatPublisherLabel(selectedPublisherData, formatMessage),
            },
        ]
        : []), true), (publisherSearchResults || [])
        .filter(function (publisher) {
        return publisher.sourceId !== (selectedPublisherData === null || selectedPublisherData === void 0 ? void 0 : selectedPublisherData.sourceId);
    })
        .map(function (publisher) { return ({
        value: publisher.sourceId,
        label: formatPublisherLabel(publisher, formatMessage),
    }); }), true); }, [selectedPublisherData, publisherSearchResults, formatMessage]);
    return (React.createElement("form", { onSubmit: function (event) {
            event.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.collections.filter.section.type",
                }), separator: false },
                React.createElement(RecekSelect, { labelId: "ui-br-agency.collections.filter.section.type", showLabel: false, value: temporaryTypeFilter, onChange: function (event) {
                        return onTypeFilterChange(event.target.value);
                    }, fullWidth: true },
                    React.createElement("option", { value: "" }, formatMessage({
                        id: "ui-br-agency.collectionsList.select.option.all",
                    })),
                    React.createElement("option", { value: CollectionTypeEnum.PUBLISHER_SERIES }, translateCollectionType(CollectionTypeEnum.PUBLISHER_SERIES, formatMessage)),
                    React.createElement("option", { value: CollectionTypeEnum.SERIES }, translateCollectionType(CollectionTypeEnum.SERIES, formatMessage)))),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.collections.filter.section.name",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.collections.filter.name.label", showLabel: false, value: temporaryNameFilter, onChange: function (event) { return onNameFilterChange(event.target.value); }, placeholder: formatMessage({
                        id: "ui-br-agency.collections.filter.placeholder.name",
                    }), fullWidth: true, marginBottom0: true })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.collections.filter.section.publisher",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-agency.collections.filter.section.publisher", showLabel: false, key: "selection-".concat(temporaryPublisherFilter || "empty", "-").concat(selectedPublisherData ? "loaded" : "loading"), asyncFilter: true, value: temporaryPublisherFilter, selectedItem: selectedPublisherData
                        ? {
                            value: selectedPublisherData.sourceId,
                            label: formatPublisherLabel(selectedPublisherData, formatMessage),
                        }
                        : undefined, loading: publishersLoading || selectedPublisherLoading, onFilter: onPublisherSearchInput, onChange: onPublisherFilterChange, dataOptions: publisherOptions })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.collections.filter.section.issn",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.collections.filter.issn.label", showLabel: false, value: temporaryIssnFilter, onChange: function (event) { return onIssnFilterChange(event.target.value); }, placeholder: formatMessage({
                        id: "ui-br-agency.collections.filter.placeholder.issn",
                    }), fullWidth: true, marginBottom0: true }))),
        React.createElement(Button, { type: "submit", marginBottom0: true }, formatMessage({ id: "ui-br-agency.button.apply" }))));
}
